<template>
<div>
    <Breadcrumbs main="Procuremnet" submain="Purchase Return" title="View" />
    <!-- Container-fluid starts-->

    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" >
                                        <label class="mr-4">Status:</label>
                                        <b-badge style="font-size: 14px;" :variant="detail.status == 'draft' ? 'primary' : detail.status == 'confirmed' ? 'success' : 'secondary'">{{ detail.status }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" >
                                        <label>Return Number</label>
                                        <input type="text" class="form-control" v-model="detail.return_number" disabled />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>GRN</label>
                                        <input type="text" class="form-control" v-model="detail.grn" disabled />
                                    </div>
                                </div>
                            </div>

                            <div class="table-responsive datatable-vue mt-4" v-if="detail.items && detail.items.length > 0">
                                <b-table show-empty stacked="md" :items="detail.items" :fields="tablefields" small>
                                    <!-- Index -->
                                    <template #cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>

                                    <!-- Item Name -->
                                    <template #cell(grn_item)="data">
                                        {{ data.item.grn_item }}
                                    </template>

                                    <!-- Editable Quantity -->
                                    <template #cell(quantity_returned)="data">
                                        <input type="number" class="form-control" v-model.number="data.item.quantity_returned" min="0" disabled />
                                    </template>
                                </b-table>
                            </div>
                            <div class="row mt-3">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Reason</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter reason..." rows="2" v-model="detail.reason" disabled></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <router-link to="/procurement/purchase-return">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    computed
} from "vue";
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import moment from "moment";

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        Multiselect,
        'v-select': vSelect
    },

    data() {
        return {
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'grn_item',
                    label: 'GRN Item'
                },
                {
                    key: 'quantity_returned',
                    label: 'Quantity Returned'
                }
            ]
        }
    },

    computed: {
        ...mapState({
            detail :  state => state.purchaseReturn.return_detail
        })
    },
    watch: {
        detail:{
            handler(newVal){
            }
        }
    },

    mounted() {
        this.$store.dispatch("purchaseReturn/fetchPurchaseReturnDetail" , this.$route.params.id)
    }
};
</script>
